import { render } from "./RequestFlat.vue?vue&type=template&id=f06c643c"
import script from "./RequestFlat.vue?vue&type=script&lang=js"
export * from "./RequestFlat.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alex/Documents/Google Ads/Panorama Residence/Panorama web/panorama-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__